import Image from "next/image";

import { roundPrice } from "../../../api/utils/helpers/roundPrice";
import { translationsContent } from "../../../localization/translations";
import { useAppDispatch } from "../../../redux/hooks";
import {
  addSignatureSaladToCart,
  deleteSignatureSaladFromCart,
  removeSignatureSaladFromCart,
  SignatureSaladItem,
} from "../../../redux/slices/cartSlice";
import { useLanguage } from "../../../store/lang.context";
import { returnIndex } from "../../../utils/returnIndex";
import { translate } from "../../../utils/translate";
import AddButton from "../../ui/button/AddButton";
import SubtractButton from "../../ui/button/SubtractButton";
import { myLoader } from "../../ui/cards/IngredientFormulaCard";
import classes from "./signatureSaladItem.module.scss";

interface Props {
  item: SignatureSaladItem;
}

const SignatureItem = ({ item }: Props) => {
  const dispatch = useAppDispatch();

  const { language } = useLanguage();

  const handleOnClick = (add: boolean) => {
    if (add) {
      dispatch(
        addSignatureSaladToCart({
          ingredient: item.ingredient,
          freeSauce: item.freeSauce,
          asNew: false,
        })
      );
    } else {
      dispatch(
        removeSignatureSaladFromCart({
          ingredient: item.ingredient,
          freeSauce: item.freeSauce,
        })
      );
    }
  };
  const handleDeleteFromCart = () => {
    dispatch(
      deleteSignatureSaladFromCart({
        ingredient: item.ingredient,
        freeSauce: item.freeSauce,
      })
    );
  };
  return (
    <div className={classes.container}>
      <div className={classes.image}>
        <Image
          src={item.ingredient.image}
          height="100%"
          width="100%"
          alt={item.ingredient.title}
          loader={myLoader}
        />
      </div>
      <div className={classes.modify}>
        <span onClick={handleDeleteFromCart}>
          {translate(translationsContent, "supprimerButton", language)}
        </span>
      </div>
      <div className={classes.details}>
        <h3>{item.ingredient[returnIndex(language)]}</h3>
        {item.freeSauce && (
          <p className={classes.freeSauceTitle}>
            {translate(translationsContent, "freeSauceCardContent", language)}:{" "}
            <b>{item.freeSauce.title}</b>
          </p>
        )}
        <div className={classes.bottomContainer}>
          <p>
            <span>{item.ingredient.calories}</span>{" "}
            {translate(translationsContent, "calories", language)}
          </p>
          <div className={classes.add}>
            <SubtractButton onClick={() => handleOnClick(false)} />
            <div className={classes.quantity}>{item.quantity}</div>
            <AddButton onClick={() => handleOnClick(true)} />
          </div>
          <div className={classes.price}>
            <p className={classes.header}>
              {translate(translationsContent, "ttc", language)}
            </p>
            <p>{roundPrice(item.itemTotal).toFixed(2)} €</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureItem;
